'use client';
import { attachFunctions } from './attachFunctions.js';
import { TYPOGRAPHY_DEFAULT_VARIANT } from './typography/domain.js';
import { reducePaletteWithModes } from './palette/metapalettes/palette/reducePaletteWithModes/reducePaletteWithModes.js';
import { DEFAULT_PALETTE } from './palette/metapalettes/palette/defaultPalette.js';
import { DEFAULT_COLOR_INVARIANTS } from './palette/metapalettes/invariants/defaultInvariants.js';
import { DEFAULT_COLORS } from './palette/metapalettes/colors/defaultColors.js';

const DEFAULT_FONT_FAMILY = '-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif;';
const BASE_THEME_DEFAULT_MODE = 'day';
/** Предназначено только для внутреннего использования */ const BASE_THEME = {
    dir: 'ltr',
    respectReducedMotion: true,
    mode: BASE_THEME_DEFAULT_MODE,
    unitBorderRadius: 8,
    unitSpace: 4,
    focusWidth: '0.1875rem',
    timingFunction: 'ease-in-out',
    typography: {
        get default () {
            return this.variants[TYPOGRAPHY_DEFAULT_VARIANT];
        },
        variants: {
            text: {
                size: 'md1',
                weight: 'regular',
                spacing: 'normal',
                family: DEFAULT_FONT_FAMILY,
                color: 'text.primary',
                weights: {
                    regular: 400,
                    medium: 500,
                    semibold: 600
                },
                spacings: {
                    tight: '-0.025em',
                    normal: '0',
                    wide: '0.025em'
                },
                sizes: {
                    lg1: [
                        18,
                        28
                    ],
                    md1: [
                        16,
                        24
                    ],
                    sm1: [
                        14,
                        20
                    ],
                    xs3: [
                        13,
                        18
                    ],
                    xs2: [
                        12,
                        16
                    ],
                    xs1: [
                        10,
                        14
                    ]
                }
            },
            heading: {
                weight: 'semibold',
                sizes: {
                    xl1: [
                        44,
                        48
                    ],
                    lg1: [
                        32,
                        36
                    ],
                    md2: [
                        28,
                        32
                    ],
                    md1: [
                        24,
                        28
                    ],
                    sm1: [
                        20,
                        28
                    ],
                    xs3: [
                        18,
                        24
                    ],
                    xs2: [
                        16,
                        22
                    ],
                    xs1: [
                        14,
                        20
                    ]
                }
            }
        }
    },
    invariants: DEFAULT_COLOR_INVARIANTS,
    colors: DEFAULT_COLORS,
    palette: reducePaletteWithModes(DEFAULT_PALETTE, BASE_THEME_DEFAULT_MODE),
    breakpoints: {
        sm1: '768px',
        md1: '1272px',
        lg1: '1504px'
    },
    shadows: {
        z50: '0px 4px 12px 0px rgba(34, 42, 55, 0.04), 0px 0px 4px 0px rgba(34, 42, 55, 0.04)',
        z100: '0px 4px 16px 0px rgba(34, 42, 55, 0.06), 0px 0px 4px 0px rgba(34, 42, 55, 0.02)',
        z300: '0px 8px 20px 0px rgba(34, 42, 55, 0.06), 0px 0px 4px 0px rgba(34, 42, 55, 0.04)',
        z500: '0px 16px 40px 0px rgba(34, 42, 55, 0.05), 0px 0px 4px 0px rgba(34, 42, 55, 0.04)',
        z100w: '0px 4px 16px 0px rgba(34, 42, 55, 0.10), 0px 0px 2px 0px rgba(34, 42, 55, 0.10)',
        z300w: '0px 8px 16px 0px rgba(34, 42, 55, 0.13), 0px 0px 2px 0px rgba(34, 42, 55, 0.10)',
        z500w: '0px 16px 32px 0px rgba(34, 42, 55, 0.13), 0px 0px 2px 0px rgba(34, 42, 55, 0.10)',
        z500b: '0px 8px 16px 0px rgba(34, 42, 55, 0.13)',
        z50t: '0px -4px 12px 0px rgba(34, 42, 55, 0.04), 0px 0px 4px 0px rgba(34, 42, 55, 0.04)',
        z100t: '0px -4px 16px 0px rgba(34, 42, 55, 0.06), 0px 0px 4px 0px rgba(34, 42, 55, 0.02)',
        z300t: '0px -8px 20px 0px rgba(34, 42, 55, 0.06), 0px 0px 4px 0px rgba(34, 42, 55, 0.04)',
        z500t: '0px -16px 40px 0px rgba(34, 42, 55, 0.05), 0px 0px 4px 0px rgba(34, 42, 55, 0.04)'
    },
    components: {},
    other: {},
    fn: {}
};
const DEFAULT_THEME = attachFunctions(BASE_THEME);

export { BASE_THEME, DEFAULT_FONT_FAMILY, DEFAULT_THEME };
//# sourceMappingURL=defaultTheme.js.map
